import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/http'
import utils from './utils/util'


import 'animate.css';
import "swiper/dist/css/swiper.css";
import './utils/rem'
import '@/scss/global.scss'

import navBar from '@/components/navBar.vue'
import footer from '@/components/footer.vue'
Vue.component('navBar', navBar)
Vue.component('pageFooter', footer)

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.prototype.$http = http
Vue.config.productionTip = false
Vue.prototype.$utils = utils

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
